import { Collapsible } from "@chakra-ui/react";
import { LuChevronDown } from "react-icons/lu";

type CollapsibleTriggerProps = {
  open: boolean;
}

function CollapsibleTrigger({ open }: CollapsibleTriggerProps) {
  return (
    <Collapsible.Trigger
      display="flex"
      gap="2"
      alignItems="center"
      fontSize="xs"
      mb="1"
      cursor="pointer"
    >
      {open ? "Collapse" : "Expand"} Insights
      <Collapsible.Indicator
        transition="transform 0.2s"
        _open={{ transform: "rotate(180deg)" }}
      >
        <LuChevronDown />
      </Collapsible.Indicator>
    </Collapsible.Trigger>
  );
}

export default CollapsibleTrigger;
